(function () {
    'use strict';
    EO_FixedButtonController.$inject = ['$scope', '$attrs', '$element'];

    function EO_FixedButtonController($scope, $attrs, $element) {
//
        var $ctrl = this;

        document.addEventListener('scroll', function (e) {
            if (window.scrollY > 100)
                hideElement('fixedButtonText');
            else
                showElement('fixedButtonText');
        })

        function hideElement(id) {

            var fixedBtn = document.getElementById('fixedButton');
            if (!fixedBtn)
                return;
            var elem = document.getElementById(id);

            if (fixedBtn && elem && !elem.classList.contains('hide-element')) {
                elem.classList.add('hide-element');
                fixedBtn.style.width = '60px';
            }


        }

        function showElement(id) {
            var fixedBtn = document.getElementById('fixedButton');
            if (!fixedBtn)
                return;
            var elem = document.getElementById(id);
            if (elem.classList.contains('hide-element')) {
                elem.classList.remove('hide-element');
                fixedBtn.style.width = '120px';
            }


        }


    }


    var EO_FixedButton = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/fixed-button/eyeson.fixed-button.template.html',
        controller: EO_FixedButtonController,
        bindings: {
            'label': '@',
            'onClick': '&'
        }


    };

    angular
        .module('tikonApp')
        .component('eoFixedButton', EO_FixedButton)


})();

